import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import TutorialScreenMediator from "./shared/TutorialScreenMediator";

export default class TutorialHubScreenMediator extends TutorialScreenMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {LanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager);
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();

        //this._target.overlayTitle.text = this._languagePack.getText('tutorial.overlay.overlayTitle');
        this._target.overlaySmartphoneTitle.text = this._languagePack.getText('tutorial.overlay.overlaySmartphoneTitle');
        this._target.overlaySmartphoneDescription.text = this._languagePack.getText('tutorial.overlay.overlaySmartphoneDescription');
        this._target.overlayLaptopTitle.text = this._languagePack.getText('tutorial.overlay.overlayLaptopTitle');
        this._target.overlayLaptopDescription.text = this._languagePack.getText('tutorial.overlay.overlayLaptopDescription');
        this._target.overlayTeaCornerTitle.text = this._languagePack.getText('tutorial.overlay.overlayTeaCornerTitle');
        this._target.overlayTeaCornerDescription.text = this._languagePack.getText('tutorial.overlay.overlayTeaCornerDescription');
        this._target.overlayColleaguesTitle.text = this._languagePack.getText('tutorial.overlay.overlayColleaguesTitle');
        this._target.overlayColleaguesDescription.text = this._languagePack.getText('tutorial.overlay.overlayColleaguesDescription');
        this._target.overlayKeyDecisionsTitle.text = this._languagePack.getText('tutorial.overlay.overlayKeyDecisionsTitle');
        this._target.overlayKeyDecisionsDescription.text = this._languagePack.getText('tutorial.overlay.overlayKeyDecisionsDescription');
        this._target.overlayMapTitle.text = this._languagePack.getText('tutorial.overlay.overlayMapTitle');
        this._target.overlayMapDescription.text = this._languagePack.getText('tutorial.overlay.overlayMapDescription');
        this._target.overlayDashboardTitle.text = this._languagePack.getText('tutorial.overlay.overlayDashboardTitle');
        this._target.overlayDashboardDescription.text = this._languagePack.getText('tutorial.overlay.overlayDashboardDescription');

        super.initializeButton("OverlayContinueButton");
    }

    _handleContinueButton() {
        super._handleContinueButton();

        this.openScreen(SkinKeyRegistry.TUTORIAL_SIM_INTERACTIONS_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 650, createjs.Ease.sineInOut)
        });
    }
}